import { Injectable } from '@angular/core';
import { WorkflowControllerService } from '@osos/shared/api';
import { RefProperty } from '@osos/shared/types';
import { Observable } from 'rxjs';

enum ScopEnum {
  Owner = 'owner',
  OriginalOwner = 'originalOwner',
  PreviousOwner = 'previousOwner',
  PreviousOriginalOwner = 'previousOriginalOwner',
}

export enum OwnerTypeEnum {
  Owner = 'owner',
  OriginalOwner = 'originalOwner',
}

export enum StepTypeEnum {
  Current = 'current',
  Previous = 'previous',
}

@Injectable()
export class WorkflowDataService extends WorkflowControllerService {
  private scopeMap = new Map<string, ScopEnum>([
    [this._getKey(StepTypeEnum.Current, OwnerTypeEnum.Owner), ScopEnum.Owner],
    [
      this._getKey(StepTypeEnum.Current, OwnerTypeEnum.OriginalOwner),
      ScopEnum.OriginalOwner,
    ],
    [
      this._getKey(StepTypeEnum.Previous, OwnerTypeEnum.Owner),
      ScopEnum.PreviousOwner,
    ],
    [
      this._getKey(StepTypeEnum.Previous, OwnerTypeEnum.OriginalOwner),
      ScopEnum.PreviousOriginalOwner,
    ],
  ]);

  getStepOwners({
    entityId,
    stepType,
    ownerType,
  }: {
    entityId: string;
    ownerType: OwnerTypeEnum;
    stepType: StepTypeEnum;
  }): Observable<Array<RefProperty>> {
    return this.getWorkFlowOwners({
      entity: entityId,
      scope: this._getOwnerScope(stepType, ownerType),
    });
  }

  private _getOwnerScope(
    stepType: StepTypeEnum,
    ownerType: OwnerTypeEnum,
  ): ScopEnum {
    return this.scopeMap.get(this._getKey(stepType, ownerType));
  }

  private _getKey(stepType: StepTypeEnum, ownerType: OwnerTypeEnum): string {
    return `${stepType}_${ownerType}`;
  }
}
